import { createSlice } from "@reduxjs/toolkit";
import { UserBuilder } from "./thunks";


const initialState = {
    user : null,
    error : null,
    isLoading : false,
    location : {name : 'Санкт-Петербург', location : [59.938678,30.314474]},
    updatePriceNotifications : [],
    regions : []
}

export const userSlice = createSlice({
    name : 'user',
    initialState,
    selectors : {
       getUserState: (state) => state.user,
       getUserError: (state) => state.error
    },
    reducers : {
        setUser(state, action){
            state.user = action.payload
        },
        setLocation(state, action){
            state.location = action.payload
        },
    },
    extraReducers : UserBuilder,
})

export const {getUserState, getUserError} = userSlice.selectors
export const {setUser, setLocation} = userSlice.actions
export default userSlice.reducer
